const utils = require('analytics/utils');
const analyticsConsts = require('analytics/constants');
const anaUtils = require('analytics/utils');
const deepExtend = require('utils/deepExtend');
const skuUtils = require('utils/Sku');
const userUtils = require('utils/User');

module.exports = function (data) {

    let currentEvent = utils.getMostRecentEvent(analyticsConsts.LINK_TRACKING_EVENT);

    let existingProductString = currentEvent.eventInfo.attributes.productStrings;

    let flashSkuId = skuUtils.IDs.FLASH;

    let newProductString;

    let internalCampaign;

    let eventStrings = currentEvent.eventInfo.attributes.eventStrings;

    if (userUtils.getBiStatus() === userUtils.types.ROUGE) {
        internalCampaign = 'flash product+flash:enroll in flash';

        newProductString = existingProductString.concat('|eVar72=product');

        eventStrings.push(analyticsConsts.Event.FLASH_ROUGE_ENROLL);
    } else {
        internalCampaign = 'flash product+flash:add to basket';

        let pPageSkuId = anaUtils.safelyReadProperty('skuList.0.skuId', data);

        newProductString = existingProductString.concat(
            `;${pPageSkuId};;;;eVar26=${pPageSkuId}|eVar72=product:flash`
        ).concat(
            `;${flashSkuId};;;;eVar26=${flashSkuId}|eVar72=product:flash`
        );
    }

    deepExtend(currentEvent, {
        eventInfo: {
            attributes: {
                actionInfo: '',
                productStrings: newProductString,
                internalCampaign,
                eventStrings
            }
        }
    });
};
